import React from "react";
import { FormattedMessage } from "react-intl";

import { Link } from "@use/react-router";

import { BaseError } from "@apps/viewer/src/ts/components/errors/BaseError";
import { colors } from "@apps/viewer/src/ts/config";

/**
 * Error message that'll be displayed if the user attempted to load a page
 * that couldn't be found.
 */
// tslint:disable-next-line variable-name
export const PageNotFound = () => {
    const errorMessage = (
        <React.Fragment>
            <FormattedMessage
                id="ErrorMessages__PageNotFound"
                defaultMessage="Vi kan desværre ikke finde den side du søgte efter."
            /><br />

            <Link to="/" className="error__pageNotFound__link">Gå til første side</Link>

            <style jsx>{`
                :global(.error__pageNotFound__link) {
                    /** Apply some margin between button and message */
                    display: inline-block;
                    margin-top: 15px;

                    /** Apply box styling */
                    border: 2px solid ${ colors.orange};
                    padding: 10px 30px;

                    /** Apply text styling */
                    color: ${ colors.orange};
                    line-height: 1em;
                    text-decoration: none;

                    /** Add hover transition */
                    transition:
                        background-color 0.1s linear,
                        color 0.1s linear;

                    &:hover {
                        background-color: ${ colors.orange};
                        color: ${ colors.white};
                    }
                }
            `}</style>
        </React.Fragment>
    );

    return <BaseError errorMessage={errorMessage} />;
};
